import { useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import LoyaltyPointComp from "../../components/LoyaltyPointComp";
import { AppContext } from "../../contexts/AppContext";

const LoyaltyPoint: React.FC = () => {
  const { findAndSetStore } = useContext(AppContext);
  const { storeId } = useParams<{ storeId: string }>();
  useEffect(() => {
    if (!storeId) return;
    findAndSetStore(storeId);
  }, [storeId]);

  return <LoyaltyPointComp />;
};

export default LoyaltyPoint;
